import axios from "axios";

/**
 * Send an AJAX call to the main plugin API route (POST).
 */
export const doAjaxCall = async (action, data) => {
  return axios
    .post(
      `${window.WPMailPro.data.api.rest_url}wpmailpro/v1/admin/${action}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": window.WPMailPro.data.api.nonce,
        },
        timeout: 15 * 1000,
      }
    )
    .then(
      (response) => {
        return Promise.resolve(response.data);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
};

/**
 * Get metrics.
 */
export const getMetrics = async (force = false, range) => {
  try {
    const payload = await doAjaxCall("metrics-get", { force, range });

    return {
      success: true,
      ...payload,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
};

/**
 * Get logs.
 */
export const getLogs = async (filters = {}, page = 1) => {
  try {
    const payload = await doAjaxCall("logs-get", { filters, page });

    return {
      success: true,
      ...payload,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
};

/**
 * Save basic fields in an option.
 */
export const saveFields = async (fields) => {
  try {
    const payload = await doAjaxCall("fields-save", { fields });

    return {
      success: true,
      ...payload,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
};

/**
 * Send a test e-mail to a specific address.
 */
export const sendTestEmail = async (email) => {
  try {
    const payload = await doAjaxCall("send-test-email", { email });

    return {
      success: true,
      ...payload,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
};

/**
 * Create a sending domain
 */
export const createDomain = async (domain) => {
  try {
    const payload = await doAjaxCall("domain-create", { domain });

    return {
      success: true,
      ...payload,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
};

/**
 * Verify a sending domain records.
 */
export const verifyRecords = async (domain) => {
  try {
    const payload = await doAjaxCall("domain-verify", { domain });

    return {
      success: true,
      ...payload,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
};

/**
 * Activate a license.
 */
export const activateLicense = async (license) => {
  try {
    const payload = await doAjaxCall("license-activate", { license });

    return {
      success: true,
      ...payload,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
};

/**
 * Deactivate a license.
 */
export const deactivateLicense = async (license) => {
  try {
    const payload = await doAjaxCall("license-deactivate", { license });

    return {
      success: true,
      ...payload,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
};

/**
 * Get an e-mail content.
 */
export const getEmailContent = async (id) => {
  try {
    const payload = await doAjaxCall("email-content-get", { id });

    return {
      success: true,
      ...payload,
    };
  } catch (error) {
    return {
      error: error.message,
    };
  }
};
